/**
 * Cera Pro regional subset script ranges (runtime + build).
 * Latin excludes Vietnamese horn letters (U+01A0–01B0) and tone letters (U+1EA0–1EF9);
 * `/vi/` loads `cera-*-vietnamese.woff2` for those blocks.
 */

/** @type {[number, number][]} */
export const CERA_REGIONAL_LATIN_RANGES = [
  [0x0020, 0x019f],
  [0x01b1, 0x024f],
  [0x0300, 0x036f],
  [0x2150, 0x215f],
  [0x2190, 0x219f],
];

/** Horn letters (ơ/ư) + precomposed Vietnamese (U+1EA0–1EF9). Requires full Cera Pro masters. */
export const CERA_REGIONAL_VIETNAMESE_RANGES = [
  [0x01a0, 0x01b0],
  [0x1ea0, 0x1ef9],
];

/** @type {[number, number][]} */
export const CERA_REGIONAL_CYRILLIC_RANGES = [
  [0x0400, 0x04ff],
  [0x0500, 0x052f],
];

/** @type {[number, number][]} */
export const CERA_REGIONAL_GREEK_RANGES = [[0x0370, 0x03ff]];

export const UNICODE_RANGE_REGIONAL_LATIN =
  "U+0020-019F,U+01B1-024F,U+0300-036F,U+2150-215F,U+2190-219F";

export const UNICODE_RANGE_REGIONAL_VIETNAMESE = "U+01A0-01B0,U+1EA0-1EF9";

/** Sample UI string used to validate Vietnamese regional subsets after build. */
export const CERA_VIETNAMESE_COVERAGE_SAMPLE = "Từ vựng học tiếng Đức ơưă";

export const UNICODE_RANGE_REGIONAL_CYRILLIC = "U+0400-04FF,U+0500-052F";

export const UNICODE_RANGE_REGIONAL_GREEK = "U+0370-03FF,U+1F00-1FFF";

/** @type {{ key: string, label: string, ranges: [number, number][] }[]} */
export const CERA_REGIONAL_SCRIPT_DEFS = [
  { key: "latin", label: "latin", ranges: CERA_REGIONAL_LATIN_RANGES },
  { key: "vietnamese", label: "vietnamese", ranges: CERA_REGIONAL_VIETNAMESE_RANGES },
  { key: "cyrillic", label: "cyrillic", ranges: CERA_REGIONAL_CYRILLIC_RANGES },
  { key: "greek", label: "greek", ranges: CERA_REGIONAL_GREEK_RANGES },
];

/**
 * @param {[number, number][]} pairs
 * @returns {string}
 */
export function glyphStringFromRanges(...pairs) {
  let out = "";
  for (const [a, b] of pairs) {
    const lo = Math.min(a, b);
    const hi = Math.max(a, b);
    for (let cp = lo; cp <= hi; cp++) {
      try {
        out += String.fromCodePoint(cp);
      } catch {
        /* invalid scalar */
      }
    }
  }
  return out;
}

/**
 * @param {string} uiLang
 * @returns {"vietnamese"|"cyrillic"|"greek"|"arabic"|null}
 */
export function ceraRegionalSupplementKeyForUiLang(uiLang) {
  const base = String(uiLang || "")
    .trim()
    .toLowerCase()
    .split(/[-_]/)[0];
  if (base === "vi") return "vietnamese";
  if (base === "ar") return "arabic";
  if (base === "uk" || base === "ru") return "cyrillic";
  if (base === "el") return "greek";
  return null;
}
